const { getElement } = window.BAO.Utils

export class SiteDrawer extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.drawers = getElement('site-drawers')
    if (!this.drawers) {
      throw new Error(
        `${this.nodeName.toLowerCase()} needs a <site-drawers> element to work`,
      )
    }
    this.drawers.drawers.push(this)

    this._isOpen = false
    this._hasMoved = false
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.drawerShouldBeMoved && !this._hasMoved) {
      this._hasMoved = true
      this.moveToElement.appendChild(this)
    }
  }

  get key () {
    return this.getAttribute('key')
  }

  get elements () {
    return {
      trigger: getElement(`[data-drawers-trigger=${this.key}]`),
      close: getElement(`[data-module-drawers-close=${this.key}]`),
    }
  }

  get isOpen () {
    return this._isOpen
  }

  set isOpen (val) {
    this._isOpen = val

    this.classList.toggle(this.config.classes.activeDrawerClass, val)

    if (val && this.key === 'butterfly-mark') {
      const iframe = this.els.butterfly?.element
      if (iframe?.dataset.src && !iframe.getAttribute('src')) {
        iframe.src = iframe.dataset.src
      }
    }
  }

  get drawerShouldBeMoved () {
    return this.hasAttribute('data-module-drawers-move-me')
  }

  get moveToElement () {
    switch (this.getAttribute('data-module-drawers-move-me')) {
      case 'root':
        return this.drawers
      default:
        return getElement(this.getAttribute('data-module-drawers-move-me'))
    }
  }

  get config () {
    return {
      classes: {
        activeDrawerClass: 'drw-Drawer-active',
      },
    }
  }
}

customElements.define('site-drawer', SiteDrawer)
